export function saltoPagina(paginas) {
  const texto = String(paginas ?? '').trim()
  if (!/^\d+$/.test(texto)) {
    throw new Error('saltoPagina debe recibir un número entero positivo')
  }

  const cantidad = Number(texto)
  if (!Number.isInteger(cantidad) || cantidad < 1) {
    throw new Error('saltoPagina debe recibir un número entero mayor o igual a 1')
  }

  return `__DOCX_SALTO_PAGINA__:${cantidad}__`
}
